import bem from 'utils/bem';

export const block = bem('instagram-autopost-modal');
